export default __webpack_public_path__ + "static/media/welcome.9c9e6aa1.png";